import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const farmaciaGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();
  
  console.log('[FarmaciaGuard] Verificando acesso:', user);
  
  if (!user) {
    // Não autenticado, redirecionar para login
    console.log('[FarmaciaGuard] Usuário não autenticado, redirecionando para /login');
    router.navigate(['/login']);
    return false;
  }

  if (user.tipo === 'farmacia') {
    // É farmácia, pode acessar
    console.log('[FarmaciaGuard] Usuário é farmácia, acesso permitido');
    return true;
  }

  // É paciente, redirecionar para dashboard do paciente
  console.log('[FarmaciaGuard] Usuário é paciente, redirecionando para /paciente/dashboard');
  router.navigate(['/paciente/dashboard']);
  return false;
};
